import { formatDate, formatNumber, formatPercent } from '@angular/common';
import { CmpsCardRowTooltipValue } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { CoachingInsightComponentAttributes } from '../../coaching-insight/oa/models/coaching.global.model';
import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export function getProgressToolTipData(
    componentAttributes: CoachingInsightComponentAttributes,
): CmpsCardRowTooltipValue[] {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;

    return [
        {
            label: translateService.instant(
                TranslationKeyMap._7372_TOTAL_OPPORTUNITIES,
            ),
            value: formatNumber(
                componentAttributes.totalOpportunities,
                userLocale,
                '1.0',
            ),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._7427_EXPECTED_OPPORTUNITIES,
            ),
            value: formatNumber(
                componentAttributes.expectedOpportunities,
                userLocale,
                '1.0',
            ),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._7481_FUNDED_COACHED_OPPORTUNITIES,
            ),
            value: formatNumber(
                componentAttributes.fundedCoachedOpps,
                userLocale,
                '1.0',
            ),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._7493_TOTAL_AGENTS,
            ),
            value: formatNumber(
                componentAttributes.totalAgents,
                userLocale,
                '1.0',
            ),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._7494___OF_AGENTS_WITH_OPPORTUNITIES,
            ),
            value: formatPercent(
                componentAttributes.pctAgentsWithOpps,
                userLocale,
                '1.0',
            ),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._9923_LAST_UPDATED,
            ),
            value: formatDate(
                new Date(componentAttributes.lastUpdated),
                'MMMM d, YYYY, hh:mm a',
                userLocale,
            ),
        },
    ];
}
